import React, { useContext } from 'react';
import { AppContext } from 'App.context.js';
import AppButton from 'Components/common/Forms/AppButton/AppButton.jsx';
import { Input, Button } from 'antd';
import { show2FAModal } from 'Components/common/TwoFactorModal/TwoFactorModal';
import Loading from 'Components/common/Loader/Loading.jsx';
import styles from './s3UserConfig.styles';
import useS3UserHook from './s3UserConfig.hook.js';
import AppModal from 'Components/common/AppModal/AppModal.jsx';

export default function S3UserConfig() {
  const { state, actions } = useS3UserHook();
  const {
    appActions: { translate, getSelectedHotel },
  } = useContext(AppContext);

  return (
    <>
      {translate('policeReport.s3UserConfig.description')}

      {state.isUserCreated && (
        <div style={{ flex: 1, marginTop: '16px' }}>
          <div>
            <b style={{ ...styles.header, marginBottom: 5, display: 'block' }}>
              {translate('policeReport.s3UserConfig.user')}
            </b>

            <Input
              bordered={false}
              value={getSelectedHotel()?.key}
              disabled={true}
              rows={4}
              style={{ backgroundColor: '#f5f5f5' }}
            />
          </div>
        </div>
      )}
      <div style={{ display: 'flex', gap: '20px', alignItems: 'flex-start', marginTop: '16px' }}>
        <div style={{ flex: 1 }}>
          <div style={{ ...styles.inputContainer, margin: 0, padding: 0 }}>
            <b style={{ ...styles.header, marginBottom: 5, display: 'block' }}>
              {translate('hbxProducts.publicSSHKey')}
            </b>

            <Input.TextArea
              bordered={false}
              value={state.sshKey}
              onChange={e => actions.setField('sshKey', e.target.value)}
              disabled={state.isUserCreated || state.isLoading}
              rows={4}
              style={{ backgroundColor: '#f5f5f5' }}
              placeholder={translate('hbxProducts.sshKeyPlaceholder')}
            />
          </div>
        </div>

        <div style={{ flex: 1 }}>
          <b style={{ ...styles.header, marginBottom: 5, display: 'block' }}>
            {translate('hbxProducts.ipAddress')}
          </b>

          {state.ips.map((ip, index) => (
            <div key={index} style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
              <Input
                disabled={state.isUserCreated || state.isLoading}
                bordered={false}
                value={state.ips[index]}
                onChange={e => {
                  const newIps = [...state.ips];

                  newIps[index] = e.target.value.replace(/[^0-9.]/g, '');

                  actions.setField('ips', newIps);
                }}
                style={{
                  backgroundColor: state.invalidIps?.includes(state.ips[index])
                    ? '#ffe6e6'
                    : '#f5f5f5',
                  flex: 1,
                  height: '38px',
                  boxSizing: 'border-box',
                  marginRight: 5,
                  padding: '0 8px',
                }}
                placeholder={translate('hbxProducts.putIp')}
              />

              {state.ips.length > 1 && (
                <Button
                  disabled={state.isUserCreated || state.isLoading}
                  type="button"
                  onClick={() => {
                    const newIps = [...state.ips];
                    const removedIp = newIps[index];

                    newIps.splice(index, 1);

                    actions.setField('removedIps', [...(state.removedIps || []), removedIp]);
                    actions.setField('ips', newIps);
                  }}
                  style={{
                    background: 'red',
                    color: 'white',
                    border: 'none',
                    padding: '2px 6px',
                    cursor: 'pointer',
                    borderRadius: '3px',
                  }}
                >
                  X
                </Button>
              )}
            </div>
          ))}

          <Button
            disabled={state.isUserCreated || state.isLoading}
            type="button"
            onClick={() => actions.setField('ips', [...state.ips, ''])}
            style={{ marginTop: 5 }}
          >
            {translate('hbxProducts.addAnotherIp')}
          </Button>
        </div>
      </div>

      <div style={styles.buttonContainer}>
        {state.isLoading && <Loading size={'small'} />}

        <AppButton
          disabled={state.isUserCreated || state.isLoading}
          text={translate('policeReport.save')}
          action={async () => {
            actions.setModal('createUserModalVisible', true);
          }}
        />
      </div>

      <AppModal
        show={state.createUserModalVisible}
        title={translate('policeReport.s3UserConfig.createModalTitle')}
        description={translate('policeReport.s3UserConfig.createModalDescription')}
        okText={translate('Ok')}
        okAction={async () => {
          const twoFAResult = await show2FAModal();

          // Only save if approved
          if (twoFAResult) actions.saveS3UserConfig();
        }}
        cancelAction={() => actions.setModal('createUserModalVisible', false)}
        closable={false}
      />
    </>
  );
}
